

export namespace Constants {
  export const API_ENDPOINT = '/api';
  export const GRAPH_API_ENDPOINT = 'https://graph.microsoft.com/';
  export const GRAPH_API_VERSION = 'v1.0';
  export const GRAPH_API_AZUREAD_ENDPOINT = 'https://graph.windows.net';
  export const COLLAB_UNIFIED_GROUPS_LINK_TARGET = 'site';
  export const COLLAB_UNIFIED_GROUPS_CONVERSATION_LINK_TARGET = 'conversations';
  export const COLLAB_UNIFIED_GROUPS_FILES_LINK_TARGET = 'documents';
  export const COLLAB_UNIFIED_GROUPS_CALENDER_LINK_TARGET = 'calendar';
  export const COLLAB_UNIFIED_GROUPS_PLANNER_LINK_TARGET = 'planner';
  export const COLLAB_UNIFIED_GROUPS_TEAMS_LINK_TARGET = 'TEAM';
  export const BOOTSTRAP_MEDIUM_DEVICE_BREAKPOINT = '(max-width: 991.98px)'; // media-breakpoint-down(md)
  export const NAVBAR_HEIGHT = '5.35rem';
  export const NAVBAR_HEIGHT_MOBILE = '3.125rem';
  export const DEFAULT_TITLE = 'RISE PDP';
  export const TRACKING_EVENT_TYPE_APP_CLICK = 'AppClick';
  export const TRACKING_EVENT_TYPE_LINK_CLICK = 'LinkClick';
  export const SHOULD_NOT_LOAD_MAIN_KEY = 'shouldNotLoadMain';

  export const PDP_ROLE_DEFAULT = 0;
  export const PDP_ROLE_ADMIN = 1;
}
